// trick to bundle the css
require('./../css/msa.css')
module.exports = require('./index')



// WEBPACK FOOTER //
// ./src/index_webpack.js